import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/equipment/_layout/rule-and-policy/')({
  beforeLoad: () => {
    throw redirect({
      to: '/equipment/rule-and-policy/assignment'
    });
  }
});